<template>
  <div class="header ">
    <div class="logoClass">
      <img class="header_logo" src="../assets/images/header_logo.png" alt="logo">
    </div>
    <div class="header_container">
      <div>
        <router-link v-for="item in data.linkItems" :key="item" :to="item.link" v-show="item.show">{{ item.name }}
        </router-link>
      </div>
      <div class="header_center" v-if="store.state.logged">
        <router-link to="/basicInformation">个人中心</router-link>
        <span class="line"> | </span>
        <a @click="logOut()">退出</a>
<!--        <el-popconfirm-->
<!--            confirm-button-text="是"-->
<!--            cancel-button-text="否"-->
<!--            title="确认退出?"-->
<!--            @confirm="quitHandle()"-->
<!--        >-->
<!--          <template #reference>-->
<!--            <a>退出</a>-->
<!--          </template>-->
<!--        </el-popconfirm>-->
      </div>
      <div class="header_login" v-else>
        <a @click="showLogin">登录</a>
        <!-- <router-link to="/companyDetails?type=1">立即入驻</router-link> -->
      </div>
    </div>

    <Login ref="loginRef"></Login>
  </div>
</template>

<script lang="ts" setup>
// 导入实例
import Login from '@/components/login.vue'
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'
import {reactive, ref} from 'vue';
import {ElMessageBox} from 'element-plus'
import {ElMessage} from 'element-plus'

// 获取apiUrl
const store: any = useStore();
// 登录弹窗
const loginRef = ref();
const showLogin = () => {
  loginRef.value.entryVisible = true
};
// 获取参数
const router: any = useRouter();
const logOut:any = () => {
  ElMessageBox.confirm(
      '您确认退出登录吗?',
      '提示',
      {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }
  )
      .then(() => {
        quitHandle()
      })
      .catch(() => {})
}
// 退出事件
const quitHandle: any = () => {
  ElMessage.success('退出成功!');
  data.logged = false;
  store.state.logged = false;
  data.linkItems[1].show = false;
  store.state.userData = null;
  //sessionStorage.removeItem('userData');
  window.sessionStorage.clear()
  router.replace('/');
}

const data: any = reactive({
  logged: store.state.logged,
  linkItems: [
    {
      name: '首页',
      link: '/',
      show: true,
    },
    {
      name: '资源中心',
      link: '/ResourceCenter',
      show: store.state.logged,
    },
    {
      name: '文档中心',
      link: '/DocumentCenter',
      show: false,
    },
    {
      name: '平台公告',
      link: '/platformAnnouncement',
      show: false,
    },
    {
      name: '联系我们',
      link: '/contactUs',
      show: false,
    },
  ],
});
</script>
<style scoped lang="scss">
.header {
  padding: 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px 30px;

  .header_container {
    display: flex;
    align-items: center;
    gap: 40px;

    > div:first-child {
      display: flex;
      align-items: center;
      gap: 40px;
    }

    a {
      color: rgb(17, 112, 218);
      font-size: 18px;
      padding: 4px 0;
      position: relative;
      text-decoration: none;
      white-space: nowrap;
      transition: color 0.2s ease;
    }

    a:hover {
      color: #446ffa;
    }

    .router-link-active:before {
      position: absolute;
      z-index: 1;
      left: 0;
      bottom: -14px;
      height: 3px;
      width: 100%;
      border-radius: 3px;
      background-color: #446ffa;
      content: "";
    }

    .header_login {
      margin: 0;
      line-height: 30px;
      border: 1px solid rgb(0, 159, 255);
      border-radius: 4px;
      overflow: hidden;
      transition: background-color 0.2s ease, border-color 0.2s ease;

      a {
        display: inline-block;
        font-size: 16px;
        margin: 0;
        padding: 0 20px;
        cursor: pointer;
        transition: color 0.2s ease;
      }

      &:hover {
        background-color: rgb(0, 159, 255);
        border-color: rgb(0, 159, 255);

        a {
          color: #fff;
        }
      }
    }

    .header_center {
      display: flex;
      align-items: center;
      // line-height: 30px;
      color: #c0c4cc;
      .line{
        padding: 0 5px 0 5px;
      }

      a {
        color: rgb(17, 112, 218);
        cursor: pointer;
      }

      .router-link-active:before {
        bottom: -14px;
      }
    }
  }
}

.header_logo {
  display: block;
  height: 77px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}

@media screen and (max-width: 1440px) {
  .header .header_container {
    gap: 16px;

    > div:first-child {
      gap: 16px;
    }
  }
}

.logoClass {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 30px;
  font-weight: 600;
}
</style>

